import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';

function AwardTimePeriod({ formIndex, options }) {
  const [timePeriod, setTimePeriod] = useState('');

  return(
    <>
      <input name={`export_list[award_infos_attributes][${formIndex}][time_period]`}
             value={timePeriod}
             hidden/>

      <CreatableSelect
        isClearable
        onChange={(e) => setTimePeriod(e.value)}
        options={options}
        placeholder="Select time period"
      />
    </>
  )
}

export default AwardTimePeriod;
